import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService } from '../vqutils/vq-alert/vq-alert.component';
import { BodyClassService } from '../vqutils/body-class.service';
import { ModalService } from '../vqutils/vq-modal/vq-modal.component';
import { ApiService } from '../services/api.service';
import { LocalStorageService } from '../services/localstorage.service';

declare let google: any;

@Component({
	selector: 'app-space-step-1',
	templateUrl: './space-step-1.component.html',
	styles: []
})
export class SpaceStep1Component implements OnInit {
	@ViewChild('map') map: ElementRef;
	@ViewChild('mapinput') mapinput: ElementRef;

	currentUser;
	isLoading: boolean = false;
	images = [];
	space: any = {
		agency: '',
		// active: true,
		display_agency: true,
		display_contact_form: true,
		display_news: true,
		display_media: true,
		// display_allo_agglo_phone: false
	};
	spaceUpdated: any = {};
	files: any = {};
	errors: any = {};
	config = {
		data: this.space,
		rows: [
			{
				fields: [
					{
						// classes: 'col-6',
						module: 'text',
						modelKey: 'name',
						label: 'Nom du chantier *',
						errors: this.errors.name,
						placeholder: 'Nom du chantier'
					}
				],
				tip: {
					classes: 'col-3',
					text: 'Indiquer le nom du chantier'
				}
			},
			{
				fields: [
					{
						// classes: 'col-6',
						module: 'text',
						modelKey: 'slug',
						label: 'Adresse url du chantier *',
						errors: this.errors.slug,
						placeholder: 'mon-chantier'
					}
				],
				tip: {
					classes: 'col-3',
					text:
						"Exemple: saisissez « mon-chantier » pour avoir l'url « https://infochantiers.vingtcinq.io/mon-chantier »"
				}
			},
			{
				fields: [
					{
						// classes: 'col-6',
						module: 'text',
						modelKey: 'email',
						label: 'Email recevant les demandes de contact',
						errors: this.errors.email,
						placeholder: 'agence@eurovia.com'
					}
				],
				tip: {
					classes: 'col-3',
					text: "Si vous choisissez de désactiver le formulaire de contact, ce champs n'est pas requis."
				}
			},
			{
				fields: [
					{
						module: 'textarea',
						modelKey: 'description',
						label: 'Description du chantier *',
						errors: this.errors.description,
						placeholder: 'Description du chantier'
					}
				],
				tip: {
					classes: 'col-3',
					text: 'Indiquer la description du chantier. Elle apparaitra sur la page de présentation du chantier'
				}
			},
			{
				fields: [
					{
						module: 'text',
						modelKey: 'facebook_url',
						label: 'Url de la page Facebook (optionnel)',
						errors: this.errors.name,
						placeholder: 'https://www.facebook.com/EuroviaGroup/'
					}
				],
				tip: {
					classes: 'col-3',
					text: "Indiquer l'url de la page facebook du chantier, si applicable."
				}
			},

			{
				fields: [
					{
						module: 'select',
						modelKey: 'agency',
						label: 'Agence *',
						errors: this.errors.agency,
						labelGetter: 'name',
						valueGetter: 'id',
						apiService: 'agencies',
						filter: {
							type: 'select'
						}
					}
				]
			},
			{
				fields: [
					{
						module: 'date',
						modelKey: 'start_date',
						label: 'Date de démarrage *',
						labelGetter: 'name',
						valueGetter: 'id',
						apiService: 'contracts',
						errors: this.errors.start_date
					}
				],
				tip: {
					text: 'Indiquer la date à laquelle le chantier doit débuter'
				}
			},
			{
				fields: [
					{
						module: 'date',
						modelKey: 'end_date',
						label: 'Date de fin *',
						labelGetter: 'name',
						valueGetter: 'id',
						apiService: 'contracts',
						errors: this.errors.end_date
					}
				],
				tip: {
					text: 'Indiquer la date à laquelle le chantier doit se terminer'
				}
			},
			{
				fields: [
					{
						module: 'text',
						modelKey: 'title_contact',
						label: 'Titre du numéro de téléphone à contacter',
						labelGetter: 'name',
						valueGetter: 'id',
						apiService: 'contracts',
						errors: this.errors.title_contact,
						placeholder: 'Titre du numéro de téléphone'
					}
				],
				tip: {
					text:
						'(optionnel) Indiquer le titre qui correspond au numéro de téléphone qui sera affiché sur la page contact'
				}
			},
			{
				fields: [
					{
						module: 'text',
						modelKey: 'phone_contact',
						label: 'Numéro de téléphone à contacter',
						labelGetter: 'name',
						valueGetter: 'id',
						apiService: 'contracts',
						errors: this.errors.phone_contact,
						placeholder: 'Numéro de téléphone'
					}
				],
				tip: {
					text: '(optionnel) Indiquer le numéro de téléphone qui sera affiché sur la page contact'
				}
			}
		]
	};
	constructor(
		private route: ActivatedRoute,
		private _router: Router,
		private _as: AlertService,
		private _bc: BodyClassService,
		private _localStorage: LocalStorageService,
		private _ms: ModalService,
		private _api: ApiService
	) { }

	ngOnInit() {
		// this._as.success('Vous ne pouvez définir qu\'un seul chef de projet');
		this.currentUser = this._localStorage.getObject('user');
		this.route.params.subscribe((params) => {
			if (params['id']) {
				this.space.id = params['id'];
				this._api.spaces.retrieve(this.space.id).subscribe(
					(data) => {
						this.space = data;
						this.initMap();
					},
					(errors) => { }
				);
			} else {
				this.initMap();
			}
		});
	}

	initMap() {
		let mapCenter;
		if (this.space.id) {
			mapCenter = {
				lat: parseFloat(this.space.latitude) || 48.735746,
				lng: parseFloat(this.space.longitude) || 2.167667
			};
		} else {
			mapCenter = { lat: 48.735746, lng: 2.167667 };
		}
		const map = new google.maps.Map(this.map.nativeElement, {
			center: mapCenter,
			zoom: 10,
			streetViewControl: false,
			mapTypeControl: false
		});

		const input = this.mapinput.nativeElement;

		const autocomplete = new google.maps.places.Autocomplete(input, { placeIdOnly: true });
		autocomplete.bindTo('bounds', map);

		map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);

		const geocoder = new google.maps.Geocoder();
		const marker = new google.maps.Marker({
			map: map
		});

		marker.setPosition(mapCenter);
		// marker.addListener('click', function () {
		//   infowindow.open(map, marker);
		// });

		autocomplete.addListener('place_changed', () => {
			const place = autocomplete.getPlace();

			if (!place.place_id) {
				return;
			}
			geocoder.geocode({ placeId: place.place_id }, (results, status) => {
				if (status !== 'OK') {
					window.alert('La géolocalisation a échouée: ' + status);
					return;
				}
				const latitude = results[0].geometry.location.lat().toFixed(6);
				const longitude = results[0].geometry.location.lng().toFixed(6);
				this.spaceUpdated.latitude = latitude;
				this.space.latitude = latitude;
				this.spaceUpdated.longitude = longitude;
				this.space.longitude = longitude;
				map.setZoom(14);
				map.setCenter(results[0].geometry.location);
				// Set the position of the marker using the place ID and location.
				marker.setPlace({
					placeId: place.place_id,
					location: results[0].geometry.location
				});
				marker.setVisible(true);
				// this.spaceUpdated
			});
		});
	}

	fileChange(event, field) {
		this.files[field] = event.srcElement.files[0];
	}

	deleteFile(file) {
		this.space[file] = '';
		this.spaceUpdated[file] = '';
		this.files[file] = '';
	}

	private _delete() {
		this._api.spaces.destroy(this.space.id).subscribe(
			(data) => {
				this._router.navigate(['/', 'home']);
				this._as.success('Le chantier a été supprimé');
			},
			(errors) => {
				this._as.danger("Le chantier n'a pas pu être supprimé");
			}
		);
	}

	delete() {
		this._ms.delete({
			confirm: () => this._delete()
		});
	}

	submit() {
		this.errors = {};
		this.isLoading = true;
		if (this.space.id) {
			const formData = Object.keys(this.spaceUpdated).reduce((fd, key) => {
				if (this.spaceUpdated.hasOwnProperty(key)) {
					fd.append(key, this.spaceUpdated[key]);
				}
				return fd;
			}, new FormData());
			if (this.files.main_photo) {
				formData.append('main_photo', this.files.main_photo);
			}
			if (this.files.logo_customer) {
				formData.append('logo_customer', this.files.logo_customer);
			}
			if (this.files.logo_contact) {
				formData.append('logo_contact', this.files.logo_contact);
			}
			if (this.files.logo_additional) {
				formData.append('logo_additional', this.files.logo_additional);
			}
			this._api.spaces.partialUpdate(this.space.id, formData, {}, true).subscribe(
				(data) => {
					this.space = data;
					this._as.success('Les informations du chantier ont été modifiées');
					this.isLoading = false;
					this.files = {};
				},
				(errors) => {
					this.errors = errors;
					this._as.danger('Des erreurs empêchent la modification du chantier');
					this.isLoading = false;
				}
			);
		} else {
			const formData = Object.keys(this.space).reduce((fd, key) => {
				if (this.space[key]) {
					fd.append(key, this.space[key]);
				}
				return fd;
			}, new FormData());
			if (this.files.main_photo) {
				formData.append('main_photo', this.files.main_photo);
			}
			if (this.files.logo_customer) {
				formData.append('logo_customer', this.files.logo_customer);
			}
			if (this.files.logo_contact) {
				formData.append('logo_contact', this.files.logo_contact);
			}
			if (this.files.logo_additional) {
				formData.append('logo_additional', this.files.logo_additional);
			}
			this._api.spaces.create(formData, {}, true).subscribe(
				(data) => {
					this._as.success('Le chantier a été créé');
					this._router.navigate(['/', 'home']);
					this.isLoading = false;
				},
				(errors) => {
					this.errors = errors;
					this._as.danger('Des erreurs empêchent la création du chantier');
					this.isLoading = false;
				}
			);
		}
	}

	getModel(key) {
		if (this.space.hasOwnProperty(key)) {
			return this.space[key];
		}
	}

	getError(key) {
		if (this.errors.hasOwnProperty(key)) {
			return this.errors[key];
		}
	}
	modelChange($event, key) {
		if (this.space.id) {
			this.spaceUpdated[key] = $event;
		} else {
			this.space[key] = $event;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/space-step-1/space-step-1.component.ts